module.exports = __webpack_public_path__ + "img/logo.089ef005.svg";